import { getOrdersReadByKeyUrl } from "../../../backendApi/backendApi";

export async function getOrderByKey$ (key: string) {
  const url = getOrdersReadByKeyUrl(key);
  const resp = await fetch(url, {
    credentials: 'include'
  })

  if(resp.ok) {
    const jsonResp = await resp.json();
    return Promise.resolve(jsonResp?.items)
  }

  return Promise.reject('Problem with getOrderByKey');
}